import ih from 'immutability-helper';
import _cloneDeep from 'lodash/cloneDeep';

import * as types from './actionTypes';
import initialState from './initialState';

const appSetupReducer = (state = _cloneDeep(initialState), action = {}) => {
  switch (action.type) {
    case types.GET_APPLICATION_LOCALES_REQUEST:
      return ih(state, {
        meta: {
          locales: {
            isLoading: { $set: true },
          },
        },
      });
    case types.GET_APPLICATION_LOCALES_SUCCESS:
      return ih(state, {
        meta: {
          locales: {
            $merge: {
              isLoading: false,
              data: action.payload.data.available_locales,
            },
          },
        },
      });
    case types.GET_APPLICATION_LOCALES_ERROR:
      return ih(state, {
        meta: {
          locales: {
            $merge: {
              isLoading: false,
              error: action.payload.error,
            },
          },
        },
      });
    case types.GET_APPLICATION_INFO_REQUEST:
      return ih(state, {
        show: {
          isLoading: { $set: true },
        },
      });
    case types.GET_APPLICATION_INFO_SUCCESS:
      return ih(state, {
        show: {
          $merge: {
            isLoading: false,
            data: action.payload.data,
          },
        },
      });
    case types.GET_APPLICATION_INFO_ERROR:
      return ih(state, {
        show: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.UPDATE_APPLICATION_INFO_REQUEST:
      return ih(state, {
        update: {
          isLoading: { $set: true },
        },
      });
    case types.UPDATE_APPLICATION_INFO_SUCCESS:
      return ih(state, {
        update: {
          $merge: {
            isLoading: false,
          },
        },
        show: {
          $merge: {
            data: action.payload.data,
          },
        },
      });
    case types.UPDATE_APPLICATION_INFO_ERROR:
      return ih(state, {
        update: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.GET_APPLICATION_PROPERTIES_REQUEST:
      return ih(state, {
        show: {
          isLoading: { $set: true },
        },
      });
    case types.GET_APPLICATION_PROPERTIES_SUCCESS:
      return ih(state, {
        show: {
          $merge: {
            isLoading: false,
            data: action.payload.data,
          },
        },
      });
    case types.GET_APPLICATION_PROPERTIES_ERROR:
      return ih(state, {
        show: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    case types.UPDATE_APPLICATION_PROPERTIES_REQUEST:
      return ih(state, {
        update: {
          isLoading: { $set: true },
        },
      });
    case types.UPDATE_APPLICATION_PROPERTIES_SUCCESS:
      return ih(state, {
        update: {
          $merge: {
            isLoading: false,
          },
        },
        show: {
          $merge: {
            data: action.payload.data,
          },
        },
      });
    case types.UPDATE_APPLICATION_PROPERTIES_ERROR:
      return ih(state, {
        update: {
          $merge: {
            isLoading: false,
            error: action.payload.error,
          },
        },
      });
    default:
      return state;
  }
};

export default appSetupReducer;
